module.exports = __webpack_public_path__ + "static/img/left-img.d7f5011.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/left-img.jpg
// module id = zn/p
// module chunks = 2